(ns frontend.ui.page.lp-portal.report.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color text-size]]
   [garden.units :refer [px]]))

(defn spacing-top
  []
  {:display    "block"
   :margin-top "16px"})


(defn sidebar-nav-link
  []
  (with-meta
    {:display           "flex"
     :padding           "1rem"
     :font-size         (text-size :xxsmall :size)
     :color             (theme/color [:sidebar-nav-link :regular :color])
     :text-transform    "uppercase"
     :font-weight       "bold"
     :letter-spacing    "2px"
     :border-left-width "3px"
     :border-left-style "solid"
     :border-color      "transparent"}
    {:pseudo
     {:hover
      {:color        (theme/color [:sidebar-nav-link :hover :color])
       :background   (theme/color [:sidebar-nav-link :hover :bg])
       :border-color (theme/color [:sidebar-nav-link :hover :border])}}}
  ))

(defn sidebar-attachments
  []
  (with-meta
    {:display           "flex"
     :padding           "1rem"
     :font-size         (text-size :xxsmall :size)
     :color             (theme/color [:sidebar-nav-link :regular :color])
     :text-transform    "uppercase"
     :font-weight       "bold"
     :letter-spacing    "2px"
     :border-left-width "3px"
     :border-left-style "solid"
     :border-top        "1px solid #e1ddd5"
     :border-color      "transparent"}
    {}
  ))

(defn sidebar-attachment-item
  []
  (with-meta
    {:display           "flex"
     :padding           "1rem"
     :font-size         (text-size :xxsmall :size)
     :color             (theme/color [:sidebar-nav-link :regular :color])
     :text-transform    "uppercase"
     :cursor            "pointer"
     :letter-spacing    "2px"
     :border-left-width "3px"
     :border-left-style "solid"
     :border-color      "transparent"}
    {:pseudo
     {:hover
      {:color        (theme/color [:sidebar-nav-link :hover :color])
       :background   (theme/color [:sidebar-nav-link :hover :bg])
       :border-color (theme/color [:sidebar-nav-link :hover :border])}}}
  ))


(defn content-column
  []
  (with-meta
    {:width "calc(100% - '200px')"}
    {}))

(defn sidebar-column
  []
  (with-meta
    {:width "200px"}
    {}))

(defn page-container
  []
  ^{:media {{:screen :only :max-width :1024px}
            {}}}
  {:display          :flex
   :flex-direction   :column
   :flex             "1 1 100%"
   :min-height       "100vh"
   :font-family      (theme/font-families :primary)
   :background-color (theme/color [:layout :primary :bg])})

(defn page-content
  []
  ^{:media {{:screen :only :max-width :1024px}
            {}}}
  {:flex           "1 1 auto"
   :display        "flex"
   :padding-bottom "50px"
  })

(defn page-content-inner
  []
  {:display   :flex
   :flex      "1 1 auto"
   :width     "100%"
   :max-width "1400px"
   :margin    "0 auto"
  })

(defn embedded-pdf-container
  []
  {:flex "1 1 auto"})

(defn left-container
  []
  ^{:media {{:screen :only :max-width (px 1023)}
            {:display "none"}
            {:screen :only :max-width (px 1400)}
            {:flex "initial"}}}
  {:flex  "0 0 auto"
   :width "240px"})

(defn toolbar-left
  []
  {:position "sticky"
   :top      "52px"})

(defn home-link-container
  []
  ^{:pseudo
    {}
    :combinators {[:> :a]
                  {:color       (theme/color [:home-link :regular :hover])
                   :line-height "1.65"
                   :font-size   (text-size :xxsmall :size)
                  }
                 }}
  {:display        "flex"
   :align-items    "center"
   :padding        "16px"
   :height         "55px"
   :background     (theme/color [:home-link :regular :bg])
   :color          (theme/color [:home-link :regular :color])
   :text-transform "uppercase"
   :font-weight    "bold"
   :letter-spacing "2px"
   :font-size      "12px"
   :border-bottom-width "1px"
   :border-bottom-style "solid"
   :border-bottom-color (theme/color [:home-link :regular :border])})

(defn home-link
  []
  ^{:pseudo {:hover {:color (theme/color [:home-link :hover :color])
                    }}}

  {:background     (theme/color [:home-link :regular :bg])
   :color          (theme/color [:home-link :regular :color])
   :text-transform "uppercase"
   :font-weight    "bold"
   :letter-spacing "2px"
   :font-size      "12px"})

(defn links-container
  []
  {:height   "calc(100vh - 157px)" ;; what is this magic number ?
   :overflow "auto"})

(defn report-container
  []
  ^{:media {{:screen :only :max-width (px 1400)}
            {:flex "initial"}
            {:screen :only :max-width (px 1023)}
            {:max-width "100%"
             :width     "100%"}}}

  {:width          "calc(100% - 240px)"
   :flex           "1 1 auto"
   :display        :flex
   :flex-direction :column
   :border-left-width "1px"
   :border-left-style "solid"
   :border-left-color (theme/color [:lp-portal :report-container :border])
   :position       "relative"})

(defn report-toolbar
  []
  ^{:media {{:screen :only :max-width (px 1023)}
            {:padding "16px"}}}
  {:padding    "14.5px 16px"
   :background (theme/color [:container-bgr :primary :bg])
   :border-bottom-width "1px"
   :border-bottom-style "solid"
   :border-bottom-color (theme/color [:lp-portal :report :toolbar :border])
   :position   "sticky"
   :top        "52px"
   :z-index    "2"})

(defn report-toolbar-title
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:font-size   (text-size :small :size)
             :line-height "1.3"}}}
  {:font-size   (text-size :medium :size)
   :line-height "1"
   :color       (theme/color [:text-strong :primary :color])})

(defn landscape-recommendation
  []
  ^{:media {{:screen :only :min-width :500px}
            {:display :none}}}
  {:margin-top    "16px"
   :font-size     (text-size :xxsmall :size)
   :background    (str (theme/color [:text :primary :color]) "0a")
   :color         (theme/color [:text-strong :primary :color])
   :border        (str "1px solid " (theme/color [:text :primary :color]))
   :border-radius "0px"
   :padding       "8px"
   :display       :flex})

(defn landscape-recommendation-icon
  []
  {:margin-top "2px"})

(defn landscape-recommendation-text
  []
  {:display     :inline-block
   :margin-left "8px"})

(defn report-toolbar-date-wrapper
  []
  {:display         "flex"
   :justify-content "center"
   :align-items     'center
   :font-size       (text-size :xsmall :size)
   :line-height     "1"
   :font-weight     "bold"
   :letter-spacing  "2.2px"
   :color           (theme/color [:text-strong :primary :color])})

(defn report-toolbar-date
  []
  {:padding "0 8px"
   :color   (theme/color [:text-strong :primary :color])})

(defn report-toolbar-download
  []
  (with-meta
    {:padding         "0 8px"
     :display         "flex"
     :justify-content "end"
     :margin-left     "auto"
     :font-size       (text-size :xxsmall :size)
     :line-height     "1"
     :font-weight     "bold"
     :letter-spacing  "2.2px"
     :text-transform  "uppercase"
     :color           (theme/color [:text-strong :primary :color])
     :cursor          "pointer"}
    {:pseudo
     {:hover
      {:color (theme/color [:text-strong :hover :color])}}}))

(defn report-content
  []
  {:display :flex})

(defn scroll-container
  []
  {:display   "block"
   :height    "100%"
   :max-width "100%"
   :padding   "0 16px"})

(defn hide-desktop
  []
  ^{:media {{:screen :only :max-width :1023px}
            {:display :block}}}
  {:display :none})

(defn report-title-desktop
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:display :none}}}
  {})

(defn report-title-mobile
  []
  ^{:media {{:screen :only :max-width :1080px}
            {:display     :flex
             :padding-top "16px"}}}
  {:display :none})
